import { render, staticRenderFns } from "./RemnantRegist.vue?vue&type=template&id=e4d8e0a4&scoped=true"
import script from "./RemnantRegist.vue?vue&type=script&lang=js"
export * from "./RemnantRegist.vue?vue&type=script&lang=js"
import style0 from "./RemnantRegist.vue?vue&type=style&index=0&id=e4d8e0a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d8e0a4",
  null
  
)

export default component.exports